<ng-template #keypadTmpl>
  <div class="keypad-body">
    <div class="keypad-labels">
      <span class="keypad-section-label hour-label">Hour</span>
      <span class="keypad-section-label min-label">Min</span>
      <span class="keypad-section-label meridiem-label"></span>
    </div>
    <div class="keypad-grids">
      <div class="hours-grid" role="listbox" aria-label="Hour">
        @for (h of hours; track h) {
          <button type="button"
                  class="keypad-btn hour-btn"
                  [class.selected]="draftHour === h"
                  role="option"
                  [attr.aria-selected]="draftHour === h"
                  (click)="selectHour(h)"
                  [attr.data-testid]="'keypad-hour-' + h">
            {{ h }}
          </button>
        }
      </div>
      <div class="minutes-column" role="listbox" aria-label="Minute">
        @for (m of minutes; track m) {
          <button type="button"
                  class="keypad-btn minute-btn"
                  [class.selected]="draftMinute === m"
                  role="option"
                  [attr.aria-selected]="draftMinute === m"
                  (click)="selectMinute(m)"
                  [attr.data-testid]="'keypad-minute-' + m">
            :{{ m.toString().padStart(2, '0') }}
          </button>
        }
      </div>
      <div class="meridiem-column" role="listbox" aria-label="AM or PM">
        <button type="button" class="keypad-btn meridiem-btn"
                [class.selected]="draftMeridiem === 'AM'"
                (click)="selectMeridiem('AM')"
                data-testid="keypad-meridiem-AM">AM</button>
        <button type="button" class="keypad-btn meridiem-btn"
                [class.selected]="draftMeridiem === 'PM'"
                (click)="selectMeridiem('PM')"
                data-testid="keypad-meridiem-PM">PM</button>
      </div>
    </div>
    <div class="keypad-footer">
      <button mat-button type="button" class="footer-btn clear-btn"
              (click)="clear()" data-testid="keypad-clear">Clear</button>
      <button mat-button type="button" class="footer-btn done-btn"
              (click)="confirm()" data-testid="keypad-confirm">Done</button>
    </div>
  </div>
</ng-template>
